{
	"ID": 25,
	"fields": {
		"isGUID": true,
		"isAgentNumber": true,
		"isPartition": true,
		"isDescription": true,
		"advanced": {
			"isCallCentreLicenceType": false,
			"isInternalNumber": true,
			"isCiscoCommonID": true,
			"isOverrideMonitoring": false,
			"isWebexCallingUserID": true,
			"isBroadworksUserID": false,
			"isOwningGroupID": true,
			"isOidOnTelServer": false,
			"isOwningDepartment": true,
			"isTeamsUserID": false,
			"isUserPrincipalName": false
		},
		"omnichannel": {
			"isAllowAnsweringConcurrentChannels": true,
			"chatIntegration": {
				"isType": true,
				"isId": true
			},
			"emailIntegration": {
				"isType": true,
				"isEmailAddress": true,
				"isId": true
			}
		},
		"isUpdateDuplicateItems": true
	}
}